<div fxLayout="column" class="layout-padd" fxLayoutGap="20px" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div fxLayout="column" class="full-w bordered-card" fxLayoutAlign="center center" style="padding: 5px;">
        <span class="mat-subheading-1">{{currPoint?.name_webshop}}</span>
        <span class="mat-caption">{{currPoint?.address | capitalize}}</span>
        <div fxLayout="row" *ngIf="currPoint?.phone_2 || currPoint.phone">
            <span class="mat-caption" *ngIf="currPoint.phone_2">{{currPoint.phone_2}}&nbsp;&nbsp;</span>
            <span class="mat-caption" *ngIf="currPoint.phone">{{currPoint.phone}}</span>
        </div>
    </div>

    <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="center center" class="layout-padd" class="text-center">

        <div fxLayoutAlign="center center">
            <i class="fas fa-exclamation-circle dark-ico" style="font-size:30px;"></i>
        </div>


        <span class="mat-subheading-1">{{'alertinvalidrubricslotComponent.orderunValid' | translate}}  </span>

        <span class="mat-subheading-1" *ngIf="errRub.rest_count && errRub.rest_count > 0"> {{'alertinvalidrubricslotComponent.leftin' | translate}}  <strong
        class="dark-ico">{{errRub.rest_count + " " + (errRub.rub_name| capitalize)}}</strong> {{'alertinvalidrubricslotComponent.messageDispon' | translate}}  </span>

        <span class="mat-subheading-1" *ngIf="errRub.hasOwnProperty('rest_count') === true && errRub.rest_count < 1"> {{'alertinvalidrubricslotComponent.noorder' | translate}}  <strong class="dark-ico">{{errRub.rub_name| capitalize}}</strong>
          {{'alertinvalidrubricslotComponent.messageDisponChange' | translate}} </span>

        <span class="mat-subheading-1" *ngIf="errRub.hasOwnProperty('rest_count') === false">{{'alertinvalidrubricslotComponent.nomore' | translate}} 
        
      <strong class="dark-ico">{{errRub.limit_count + " " + (errRub.rub_name | capitalize)}}</strong> {{'alertinvalidrubricslotComponent.byorder' | translate}}      </span>

    </div>

    <div class="full-w">
        <button mat-stroked-button class="dark-ico" fxFlex (click)="closeDial()" angulartics2On="click" angularticsAction="closeInvalidRubricSlotDial" angularticsCategory="order">
      <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
    </button>
    </div>

</div>